import React from "react";
import { AnimatePresence } from "framer-motion";

export default ({ children }) => {
  return <AnimatePresence initial={false}>{children}</AnimatePresence>;
};
